import { instanceVclaim } from "App/constants"
import { getUserName } from "App/utils/cookies"

export const deleteSuratKontrol = async (nomor_surkon) => {
  try {
    const api = await instanceVclaim.delete(
      "api/v1/emr/bridging/rencana-kontrol/delete",
      {
        data: {
          nomor_surat_kontrol: nomor_surkon,
          user: getUserName(),
        },
      },
    )


    const res = api.data
    if (res.metaData.code === 200) {
      return {
        state: true,
        message: res.metaData.message,
      }
    } else {
      return {
        state: false,
        message: res.metaData.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error.response.data.metaData.message,
    }
  }
}
